import React   from 'react';
import { Marker } from 'react-google-maps';

export default (props) => {
    return (
        <Marker position={{ lat: props.lat, lng: props.lng }} />
    )
}